















































import { Component, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { OpportunityDetailsModule } from '@/store/modules/opportunityDetails';

@Component({ name: 'OpportunityDescriptionEdit' })
export default class extends GiganautVueDialog {
  description = '';
  public editorKey = 0;
  public editorReady = false;

  get opportunity() { return OpportunityDetailsModule.opportunity; }
  get saving() { return OpportunityDetailsModule.saving; }

  @Watch('dialog')
  async onDialogChanged(val: boolean) {
    if (val && this.opportunity) {
      this.editorReady = false;
      this.description = this.opportunity.description || '';
      this.editorKey++;
      this.$nextTick(() => {
        this.editorReady = true;
      });
    } else {
      this.editorReady = false;
    }
  }

  async save() {
    if (!(this.$refs.form as any).validate() || !this.opportunity) return;
    await OpportunityDetailsModule.updateDescription({
      id: this.opportunity.id,
      richText: this.description,
      updatedAt: this.opportunity.updatedAt,
    });
    this.dialog = false;
  }
}
